<template>
  <div class="container">
    <div class="row h-50">
      <div
        v-if="loading"
        class="row d-flex justify-content-center align-middle my-4"
      >
        <h3>Loading magical things :)</h3>
      </div>
      <div class="col-8 offset-2 my-4" v-else>
        <h2 class="message">TME - Create Account [DEV]</h2>
        <p>
          Click Submit when you have filled out the form to create an account.
        </p>
        <p>
          <label class="message" for="givenName">First Name</label>
          <input
            class="form-control my-2"
            id="givenName"
            v-model="givenName"
            type="text"
            name="givenName"
          />
          <label class="message" for="sn">Last Name</label>
          <input
            class="form-control my-2"
            id="sn"
            v-model="sn"
            type="text"
            name="sn"
          />
          <label class="message" for="mail">Email</label>
          <input
            class="form-control my-2"
            id="mail"
            v-model="mail"
            type="text"
            name="mail"
          />
          <label class="message" for="telephoneNumber">Mobile Phone</label>
          <input
            class="form-control my-2"
            id="telephoneNumber"
            v-model="telephoneNumber"
            type="text"
            name="telephoneNumber"
          />
          <label class="message" for="password">Password</label>
          <input
            class="form-control my-2"
            id="password"
            v-model="password"
            type="text"
            name="password"
          />
        </p>
        <div class="py-3" style="text-align: center">
          <button class="ty-button" v-on:click="createAccount">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "frtmecreate",
  data: function () {
    return {
      sn: null,
      givenName: null,
      mail: null,
      telephoneNumber: null,
      password: null,
      loading: false,
    };
  },
  methods: {
    createAccount: function () {
      if (
        !this.sn ||
        !this.givenName ||
        !this.mail ||
        !this.telephoneNumber ||
        !this.password
      ) {
        alert("Please fill out all fields");
        return;
      }
      const data = JSON.stringify({
        sn: this.sn,
        givenName: this.givenName,
        mail: this.mail,
        telephoneNumber: this.telephoneNumber,
        password: this.password,
      });

      const url =
        "https://6o7dxnzfw4.execute-api.us-east-1.amazonaws.com/staging/create";

      const config = {
        method: "post",
        url: url,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      this.axios(config)
        .then((response) => {
          this.loading = false;
          // eslint-disable-next-line no-console
          console.log(response);
          this.vehicleData = response.data;
          alert(`Account Created!`);
        })
        .catch((error) => {
          this.loading = false;
          // eslint-disable-next-line no-console
          console.log(error);
          alert(`Well that was unexpected.  ${error}`);
        });
    },
  },
};
</script>

<style>
</style>